import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Appointment } from '@apis'
import { store, Actions } from '@store'
const useInstantAppointmentActions = ({ selector }) => {
  const initialAlertInfo = {
    type: '',
    id: '',
    status: '',
  }
  const [alertInfo, setAlertInfo] = useState(initialAlertInfo)
  const [loading, setLoading] = useState<boolean>(false)
  const [visible, setVisible] = useState<boolean>(false)
  const { data: appointmentConsultDashboard } = useSelector(
    (state: any) => state.appointmentConsultDashboard,
  )

  const handleClickBtn = (event) => {
    const target = event.target as HTMLElement
    const cross = target.closest('[data-cross-type]')
    if (!!cross) {
      const attribute = cross.getAttribute('data-cross-type')
      const splitAttribute = attribute.split('-')
      switch (splitAttribute[0]) {
        case 'confirm':
          setAlertInfo({
            type: splitAttribute[0],
            id: splitAttribute[1],
            status: 'Confirmed',
          })
          setVisible(true)
          break
        case 'queue':
          setAlertInfo({
            type: splitAttribute[0],
            id: splitAttribute[1],
            status: 'Queue',
          })
          setVisible(true)
          break
      }
    }
  }
  const handleClose = () => {
    setVisible(false)
    setAlertInfo(initialAlertInfo)
  }

  const handleClickYes = async () => {
    setLoading(true)
    await Appointment.updateStatus({
      data: {
        status: alertInfo?.status,
        type: 'Instant',
      },
      id: alertInfo?.id,
      state: selector,
      action: 'remove',
    })
      .then((resp) => {
        if (resp?.status == 'Confirmed') {
          store.dispatch(
            Actions.set('appointmentConsultDashboard', {
              ...appointmentConsultDashboard,
              nextInstantAppointment: resp,
            }),
          )
        }

        if (resp?.status == 'Queue') {
          store.dispatch(Actions.append('queueAppointments', resp))
        }

        setVisible(false)
      })
      .catch(() => {})
    setLoading(false)
  }
  return {
    handleClickBtn,
    alertInfo,
    loading,
    visible,
    handleClose,
    handleClickYes,
  }
}

export default useInstantAppointmentActions
